/**
 * House Ads display adapter.
 *
 * House inventory is campaign-backed (creatives via AdPlacement), not third-party
 * network tags. This adapter is registered so the display resolver treats `house`
 * as a first-class provider key; mount returns null (safe no-ad) if invoked.
 */

/**
 * @param {string} [_loaderUrl]
 * @returns {Promise<void>}
 */
export function ensureHouseAdsScript(_loaderUrl) {
  return Promise.resolve();
}

/**
 * @param {HTMLElement} _container
 * @param {object} _network
 * @returns {null}
 */
export function mountHouseAdsUnit(_container, _network) {
  return null;
}
